var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.396,
    height: 29.374,
    viewBox: "0 0 36.396 29.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#fff;stroke-width:0.9px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.683 0.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.317,28.474h7.089a1.772,1.772,0,0,0,1.772-1.772V14.178h1.772a1.772,1.772,0,0,0,1.475-2.755L191.336.789a1.772,1.772,0,0,0-2.949,0L181.3,11.423a1.772,1.772,0,0,0,1.475,2.755h1.772V26.7A1.772,1.772,0,0,0,186.317,28.474Zm3.544-23.507,3.777,5.666h-.233a1.772,1.772,0,0,0-1.772,1.772V24.93h-3.545V12.406a1.772,1.772,0,0,0-1.772-1.772h-.233Z",
    transform: "translate(-161.119 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.317,81.385h7.089a1.772,1.772,0,0,0,1.772-1.772V74.178H46.95a1.772,1.772,0,0,0,1.475-2.755L41.336,60.789a1.772,1.772,0,0,0-2.949,0L31.3,71.423a1.772,1.772,0,0,0,1.475,2.755h1.772v5.435A1.772,1.772,0,0,0,36.317,81.385Zm3.544-16.418,3.777,5.666h-.233a1.772,1.772,0,0,0-1.772,1.772v5.435H38.089V72.406a1.772,1.772,0,0,0-1.772-1.772h-.233Z",
    transform: "translate(-28.841 -52.911)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseProfileIcon);
export default __webpack_public_path__ + "static/media/release-profile-icon.1d08d6d5622d8e9c6f2ab1fbbaab7938.svg";
export { ForwardRef as ReactComponent };